module.exports = __webpack_public_path__ + "files/56910db71972f41c71bbc155ee236c8d.svg";